import { client } from '../../../../../App';
import { GET_AUTOMATED_COLUMNS } from '../../../../../queries/widgets';
import { SQUAD_DEFAULT_ISIN } from './templateConstants';
import { parseSquadSrriLevel } from './squadSrriLevel';

/** Dynamic config for Axion `cixon_stammdaten_extension.srriwert` (SRRI / SRI 1–7). */
export const SQUAD_SRRIWERT_CELL_CONFIG = {
  isDynamic: true,
  fields: [
    {
      type: 'table',
      table: 'cixon_stammdaten_extension',
      field: 'srriwert',
      valueType: 'string',
    },
  ],
} as const;

export function resolveSquadFundIsin(pdfOrForm?: any, template?: any): string {
  const fromHistory = String(pdfOrForm?.historyIsin || '').trim();
  if (fromHistory) return fromHistory.toUpperCase();
  const typed = pdfOrForm?.fondsdaten?.isin;
  // A dynamic cell is no ISIN — String() of it would yield "[object Object]".
  const fromFondsdaten = typed && typeof typed === 'object' ? '' : String(typed || '').trim();
  if (fromFondsdaten) return fromFondsdaten.toUpperCase();
  const fromTemplate = String(template?.isins?.[0] || pdfOrForm?.template?.isins?.[0] || '').trim();
  if (fromTemplate) return fromTemplate.toUpperCase();
  return SQUAD_DEFAULT_ISIN;
}

export function formatSquadUntil(dateStr?: string | null): string | undefined {
  if (!dateStr) return undefined;
  const raw = String(dateStr).trim();
  const isoPart = raw.match(/^(\d{4}-\d{2}-\d{2})/)?.[1];
  if (isoPart) return isoPart;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return undefined;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export { parseSquadSrriLevel } from './squadSrriLevel';

/**
 * Fetch SRRI (1–7) from `cixon_stammdaten_extension.srriwert` for the fund ISIN.
 * Returns null on missing data / errors (caller keeps fallback).
 */
export async function fetchSquadSrriwert(
  isin: string,
  until?: string | null,
): Promise<number | null> {
  const fundIsin = String(isin || '').trim().toUpperCase();
  if (!fundIsin) return null;
  try {
    const res = await client.query({
      query: GET_AUTOMATED_COLUMNS,
      variables: {
        param: {
          data: [[SQUAD_SRRIWERT_CELL_CONFIG]],
          isin: fundIsin,
          until: formatSquadUntil(until) || undefined,
        },
      },
      fetchPolicy: 'network-only',
    });
    return parseSquadSrriLevel(res?.data?.getAutomatedColumns?.[0]?.[0]);
  } catch {
    return null;
  }
}
